export const STORE_TOOLBOX_ADDED_SENT = 'store_toolbox_added_sent';
export const STORE_TOOLBOX_DELETED = 'store_toolbox_deleted';
export const STORE_TOOLBOX_FAILED = 'store_toolbox_failed';
export const STORE_TOOLBOX_PENDING = 'store_toolbox_pending';
export const STORE_TOOLBOX_LOADED = 'store_toolbox_loaded';
export const STORE_TOOLBOX_RESET_STATUS = 'store_toolbox_reset_status';
export const STORE_TOOLBOX_SENDING = 'store_toolbox_sending';
export const STORE_TOOLBOX_UPDATED_SENT = 'store_toolbox_updated_sent';
